import React from 'react';

import fetch from '../../fetch';

const analysisByFile=(keywords) => {

    const defaultsParams = {
    };

    return fetch.post('dossier/analysis/byfile', Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    });
}

export default {
    analysisByFile
}